// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/CompromissosServicos_SalvaNovoCompromissoServicoInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract for POST /compromissos_servicos/salvaNovoCompromissoServico
 *
 * Validates CREATE of compromisso_servico with nested OrcamentoServico.
 */
import type { CompromissoServicoNestedInputRow } from './CompromissoServicoNestedInputRow'
import type { OrcamentoServicoNestedInputRow } from './OrcamentoServicoNestedInputRow'
import { registerContract } from './validate'

export interface CompromissosServicos_SalvaNovoCompromissoServicoInput {
CompromissoServico: CompromissoServicoNestedInputRow
OrcamentoServico: OrcamentoServicoNestedInputRow
}

registerContract('CompromissosServicos_SalvaNovoCompromissoServicoInput', {
  CompromissoServico: {
    type: 'object',
    required: true,
    fields: {
      compromisso_servico_id: { type: 'number',  required: true },
      compromisso_id:         { type: 'number',  required: true },
    },
  },
  OrcamentoServico: {
    type: 'object',
    required: true,
    fields: {
      orcamento_servico_id:      { type: 'number',  required: true },
      orcamento_id:              { type: 'number',  required: false },
      orcamento_servico_qtd:     { type: 'number',  required: false },
      orcamento_servico_tipo:    { type: 'number',  required: false },
      orcamento_servico_user_id: { type: 'string',  required: false },
      servico_valor:             { type: 'number',  required: false },
      servico_id:                { type: 'number',  required: false },
      orcamento_servico_status:  { type: 'number',  required: false },
    },
  },
})
